import React from 'react';

import {Button, ListGroup, Modal} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock} from '@fortawesome/free-solid-svg-icons';

import {ICoursePreview} from 'shared/utils/course-preview';

import './styles.scss';

export interface ICourseModalProps {
    show: boolean;
    onHide: () => void;
    coursePreview?: ICoursePreview;
}

export const CoursePreviewModal = ({show, onHide, coursePreview}: ICourseModalProps) => {
    if (!coursePreview) return null;

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className="course-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center modal-title">{coursePreview.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pb-0">
                <div className="modal-banner">
                    <img
                        src={coursePreview.imgSRC}
                        alt={coursePreview.name}
                    />
                </div>
                <div className="course-meta">
                    <div className="course-meta__item">
                        <div className="meta-label">Full Access</div>
                        <div className="meta-value">{coursePreview.details.cost}</div>
                    </div>
                    <div className="course-meta__item">
                        <div className="meta-label">Subject Area</div>
                        <div className="meta-value">{coursePreview.details.subject_area}</div>
                    </div>
                    <div className="course-meta__item">
                        <div className="meta-label">Suggested Duration</div>
                        <div className="meta-value">{coursePreview.details.suggested_duration}</div>
                    </div>
                </div>
                <p className="description">{coursePreview.description}</p>
                <ListGroup variant="flush" className="mt-3">
                    {coursePreview.activities.map((activity, index) => (
                        <ListGroup.Item key={index}>
                            <div className="course-module">
                                <span
                                    className={
                                        activity.locked
                                            ? 'lock-icon visible'
                                            : 'lock-icon invisible'
                                    }
                                >
                                    <FontAwesomeIcon icon={faLock} fixedWidth />
                                </span>
                                <span className="module-title">
                                    {activity.name}
                                </span>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer >
                <Button onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};